import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export const subscriptionKeys = {
  all: ['subscription'] as const,
  status: () => [...subscriptionKeys.all, 'status'] as const,
  usage: () => [...subscriptionKeys.all, 'usage'] as const,
};

export function useSubscriptionStatus() {
  return useQuery({
    queryKey: subscriptionKeys.status(),
    queryFn: () => api.subscription.getStatus(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
}

export function useSubscriptionUsage() {
  return useQuery({
    queryKey: subscriptionKeys.usage(),
    queryFn: () => api.subscription.getUsage(),
    staleTime: 60 * 1000, // 1 minute
  });
}
